import { Typography, Box } from "@mui/material";
import { ErrorMessage, Field, useFormikContext } from "formik";
import React, { useLayoutEffect } from "react";
import TextError from "../TextError";

const FormikRadio = (props) => {
  const {
    label,
    name,
    validation,
    options,
    dependent,
    hidden,
    arrayindex,
    manualValidation,
    errors,
    arrayvalues,
    len,
    ...rest
  } = props;
// console.log(name,options,"uuuuu")
const {values,setFieldValue} = useFormikContext();


useLayoutEffect(() => {
  
  /** Checking for the gender of insured when dom mounted
   * then hiding pregancy details for male insured,
   * also setting field to no to by pass validation 
   **/
  
   const insuredGender = values?.primaryDetails?.LifeAssured?.Gender;
  // console.log("Layout effect called !>>>>", insuredGender);
  if (insuredGender === "M") {
    console.log("hidding pregnancy details");
    setFieldValue(
      "pedQuestionnPrimary.FQ_IsPregnant.QuestionValue",
      "N"
    );
    setFieldValue(
      "pedQuestionnPrimary.FQ_IsGynaecological.QuestionValue",
      "N"
    );
    setFieldValue(
      "pedQuestionnPrimary.FQ_IsMiscarriages.QuestionValue",
      "N"
    );
    setFieldValue(
      "pedQuestionnPrimary.FQ_IsdeliveryDate.QuestionValue",
      "N"
    );
    setFieldValue(
      "pedQuestionnPrimary.FQ_IsdeliveryDate.Reason",
      "null"
    );

    if (name === "pedQuestionnPrimary.FQ_IsPregnant.QuestionValue") {
      document
        .getElementById("pedQuestionnPrimary.FQ_IsPregnant")
        .closest(".mb-3")
        .setAttribute("hidden", true);
      // document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Quantity').closest('.mb-3').setAttribute('hidden', true)
      // document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Type').closest('.mb-3').setAttribute('hidden', true)
    }
    if (name === "pedQuestionnPrimary.FQ_IsGynaecological.QuestionValue") {
      document
        .getElementById("pedQuestionnPrimary.FQ_IsGynaecological")
        .closest(".mb-3")
        .setAttribute("hidden", true);
    }
    if (name === "pedQuestionnPrimary.FQ_IsMiscarriages.QuestionValue") {
      document
        .getElementById("pedQuestionnPrimary.FQ_IsMiscarriages")
        .closest(".mb-3")
        .setAttribute("hidden", true);
    }
    if (name === "pedQuestionnPrimary.FQ_IsdeliveryDate.QuestionValue") {
      document
        .getElementById("pedQuestionnPrimary.FQ_IsdeliveryDate")
        .closest(".mb-3")
        .setAttribute("hidden", true);
    }
  }
}, []);

  return (
    <div className=" form-control ">
      <div className="d-flex justify-content-between">
        <div>
          <label>{label}</label>
        </div>
        <div>
          <Field
            name={name}
            {...rest}
           
          >
            {({ field, form, setErrors }) => {
              const { setFieldValue, setFieldError, values } = form;

              const handleChange = (val) => {
                console.log('name in radio', name)
                console.log('val in radio', val.target.value)

                if (name === "primaryDetails.LifeAssured.Gender") {
                  setFieldValue("Proposer.Gender", val.target.value);
                  if (
                    val.target.value !== undefined &&
                    val.target.value === "M"
                  ) {
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsPregnant.QuestionValue",
                      "N"
                    );
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsGynaecological.QuestionValue",
                      "N"
                    );
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsMiscarriages.QuestionValue",
                      "N"
                    );
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsdeliveryDate.QuestionValue",
                      "N"
                    );
                  }else{
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsPregnant.QuestionValue",
                      ""
                    );
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsGynaecological.QuestionValue",
                      ""
                    );
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsMiscarriages.QuestionValue",
                      ""
                    );
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsdeliveryDate.QuestionValue",
                      "null"
                    );
                    setFieldValue(
                      "pedQuestionnPrimary.FQ_IsdeliveryDate.Reason",
                      "null"
                    );
                  }
                }
               
                if (name === 'pedQuestionnPrimary.GQ_IsDeformity.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsDeformity.Reason', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsDeformity.Type', '')
                    console.log('hhf', document.getElementById('pedQuestionnPrimary.GQ_IsDeformity.Reason').closest('.mb-3'))
                    document.getElementById('pedQuestionnPrimary.GQ_IsDeformity.Reason').closest('.mb-3').removeAttribute('hidden')
                    console.log('doc', document.getElementById('pedQuestionnPrimary.GQ_IsDeformity.Type').closest('div').closest('.mb-3'))
                    document.getElementById('pedQuestionnPrimary.GQ_IsDeformity.Type').closest('div').closest('.mb-3').removeAttribute('hidden')


                    setFieldValue('pedQuestionnPrimary.GQ_IsDeformity.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsDeformity.Type', '')
                    document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Type').closest('.mb-3').removeAttribute('hidden')


                  } else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsDeformity.Reason').closest('.mb-3').setAttribute('hidden', true)
                    document.getElementById('pedQuestionnPrimary.GQ_IsDeformity.Type').closest('div').closest('.mb-3').setAttribute('hidden', true)

                    setFieldValue('pedQuestionnPrimary.GQ_IsDeformity.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsDeformity.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsDeformity.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.GQ_IsLeave.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsLeave.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsLeave.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.GQ_IsLeave.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsLeave.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsLeave.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.GQ_IsLeave.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsLeave.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsLeave.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.GQ_IsTreatment.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsTreatment.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsTreatment.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.GQ_IsTreatment.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsTreatment.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsTreatment.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.GQ_IsTreatment.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsTreatment.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsTreatment.Reason', 'null')

                  }
                }

                if (name === 'pedQuestionnPrimary.FQ_IsGynaecological.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.FQ_IsGynaecological.Reason', '')
                    document.getElementById('pedQuestionnPrimary.FQ_IsGynaecological.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.FQ_IsGynaecological.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsGynaecological.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.FQ_IsGynaecological.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.FQ_IsGynaecological.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsGynaecological.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.FQ_IsGynaecological.Reason', 'null')

                  }
                }

                if (name === 'pedQuestionnPrimary.FQ_IsMiscarriages.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.FQ_IsMiscarriages.Reason', '')
                    document.getElementById('pedQuestionnPrimary.FQ_IsMiscarriages.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.FQ_IsMiscarriages.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsMiscarriages.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.FQ_IsMiscarriages.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.FQ_IsMiscarriages.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsMiscarriages.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.FQ_IsMiscarriages.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.GQ_IsAdventurious.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsAdventurious.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsAdventurious.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.GQ_IsAdventurious.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsAdventurious.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsAdventurious.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.GQ_IsAdventurious.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsAdventurious.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsAdventurious.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.GQ_IsCriminal.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsCriminal.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsCriminal.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.GQ_IsCriminal.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsCriminal.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsCriminal.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.GQ_IsCriminal.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsCriminal.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsCriminal.Reason', 'null')

                  }
                }

                if (name === 'pedQuestionnPrimary.GQ_IsExistRejected.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsExistRejected.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsExistRejected.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.GQ_IsExistRejected.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsExistRejected.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsExistRejected.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.GQ_IsExistRejected.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsExistRejected.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsExistRejected.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsAliment.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsAliment.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsAliment.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsAliment.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAliment.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsAliment.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsAliment.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAliment.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAliment.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsAnaemia.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsAnaemia.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsAnaemia.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsAnaemia.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAnaemia.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsAnaemia.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsAnaemia.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAnaemia.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAnaemia.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsAsthma.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsAsthma.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsAsthma.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsAsthma.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAsthma.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsAsthma.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsAsthma.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAsthma.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAsthma.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsAdventurous.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsAdventurous.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsAdventurous.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsAdventurous.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAdventurous.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsAdventurous.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsAdventurous.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAdventurous.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsAdventurous.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsENT.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsENT.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsENT.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsENT.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsENT.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsENT.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsENT.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsENT.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsENT.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsGoodhealth.QuestionValue') {
                  if (val.target.value === 'N') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsGoodhealth.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsGoodhealth.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsGoodhealth.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsGoodhealth.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsGoodhealth.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsGoodhealth.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsGoodhealth.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsGoodhealth.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsHIV.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsHIV.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsHIV.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsHIV.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHIV.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsHIV.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsHIV.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHIV.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHIV.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsHernia.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsHernia.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsHernia.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsHernia.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHernia.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsHernia.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsHernia.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHernia.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHernia.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsHospital.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsHospital.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsHospital.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsHospital.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHospital.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsHospital.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsHospital.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHospital.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsHospital.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.MQ_IsNervous.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.MQ_IsNervous.Reason', '')
                    document.getElementById('pedQuestionnPrimary.MQ_IsNervous.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.MQ_IsNervous.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsNervous.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.MQ_IsNervous.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.MQ_IsNervous.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.MQ_IsNervous.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.MQ_IsNervous.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.FQ_IsdeliveryDate.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.FQ_IsdeliveryDate.Reason', '')
                    document.getElementById('pedQuestionnPrimary.FQ_IsdeliveryDate.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.FQ_IsdeliveryDate.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsdeliveryDate.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.FQ_IsdeliveryDate.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.FQ_IsdeliveryDate.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsdeliveryDate.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.FQ_IsdeliveryDate.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.FQ_IsPregnant.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.FQ_IsPregnant.Reason', '')
                    document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Reason').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Quantity').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Type').closest('.mb-3').removeAttribute('hidden')


                    setFieldValue('pedQuestionnPrimary.FQ_IsPregnant.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsPregnant.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Reason').closest('.mb-3').setAttribute('hidden', true)
                    document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Quantity').closest('.mb-3').setAttribute('hidden', true)
                    document.getElementById('pedQuestionnPrimary.FQ_IsPregnant.Type').closest('.mb-3').setAttribute('hidden', true)

                    setFieldValue('pedQuestionnPrimary.FQ_IsPregnant.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.FQ_IsPregnant.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.FQ_IsPregnant.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.GQ_IsTobacco.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsTobacco.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsTobacco.Reason').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('pedQuestionnPrimary.GQ_IsTobacco.Quantity').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('pedQuestionnPrimary.GQ_IsTobacco.Type').closest('.mb-3').removeAttribute('hidden')


                    setFieldValue('pedQuestionnPrimary.GQ_IsTobacco.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsTobacco.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsTobacco.Reason').closest('.mb-3').setAttribute('hidden', true)
                    document.getElementById('pedQuestionnPrimary.GQ_IsTobacco.Quantity').closest('.mb-3').setAttribute('hidden', true)
                    document.getElementById('pedQuestionnPrimary.GQ_IsTobacco.Type').closest('.mb-3').setAttribute('hidden', true)

                    setFieldValue('pedQuestionnPrimary.GQ_IsTobacco.Quantity', '0')
                    setFieldValue('pedQuestionnPrimary.GQ_IsTobacco.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsTobacco.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.GQ_IsAlcohol.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsAlcohol.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsAlcohol.Reason').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('pedQuestionnPrimary.GQ_IsAlcohol.Quantity').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('pedQuestionnPrimary.GQ_IsAlcohol.Type').closest('.mb-3').removeAttribute('hidden')


                    setFieldValue('pedQuestionnPrimary.GQ_IsAlcohol.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsAlcohol.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsAlcohol.Reason').closest('.mb-3').setAttribute('hidden', true)
                    document.getElementById('pedQuestionnPrimary.GQ_IsAlcohol.Quantity').closest('.mb-3').setAttribute('hidden', true)
                    document.getElementById('pedQuestionnPrimary.GQ_IsAlcohol.Type').closest('.mb-3').setAttribute('hidden', true)

                    setFieldValue('pedQuestionnPrimary.GQ_IsAlcohol.Quantity', '0')
                    setFieldValue('pedQuestionnPrimary.GQ_IsAlcohol.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsAlcohol.Reason', 'null')

                  }
                }
                if (name === 'pedQuestionnPrimary.GQ_IsDrugs.QuestionValue') {
                  if (val.target.value === 'Y') {
                    setFieldValue('pedQuestionnPrimary.GQ_IsDrugs.Reason', '')
                    document.getElementById('pedQuestionnPrimary.GQ_IsDrugs.Reason').closest('.mb-3').removeAttribute('hidden')

                    setFieldValue('pedQuestionnPrimary.GQ_IsDrugs.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsDrugs.Type', '')
                  }else {
                    document.getElementById('pedQuestionnPrimary.GQ_IsDrugs.Reason').closest('.mb-3').setAttribute('hidden', true)
                    setFieldValue('pedQuestionnPrimary.GQ_IsDrugs.Quantity', '')
                    setFieldValue('pedQuestionnPrimary.GQ_IsDrugs.Type', 'null')
                    setFieldValue('pedQuestionnPrimary.GQ_IsDrugs.Reason', 'null')

                  }
                }
                setFieldValue(name, val.target.value)

              }

              return options.map((option) => {
                //console.log('radio', field)

                return (
                  <div
                    className="form-check form-check-inline "
                    key={option.value}
                  >
                    {manualValidation !== undefined ? (
                      <Field
                        type="radio"
                        className="form-check-input "
                        id={field.name}
                        {...field}
                        value={option.value}
                        onChange={(val) => handleChange(val, name)}
                      />
                    ) : (
                      <Field
                        type="radio"
                        className="form-check-input "
                        id={field.name}
                        {...field}
                        value={option.value}
                        onChange={(val) => handleChange(val, name)}
                      />
                    )}

                    <label htmlFor={field.name}>{option.label}</label>
                  </div>
                );
              });
            }}
          </Field>
        </div>
      </div>

      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default FormikRadio;
